var themes = {
  light: {
    primary: '#0086FF',
    secondary: '#FFFFFF',
    accent: '#82B1FF',
    error: '#FF253A',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  },
  dark: {
    primary: '#0086FF',
    secondary: '#505050',
    accent: '#82B1FF',
    error: '#FF253A',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  }
}

export default {
  name: 'MagaluPay',
  dark: false,
  options: {
    customProperties: true,
    disableErrorMessages: true,
    disableAlertMessages: true,
    disableSuccessMessages: true,
    disableFormValidation: true,
    iconError: 'fas fa-exclamation-triangle'
  },
  themes: themes
}
